import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GeneralConfigType, InteractionType, KeyValueSet, LocalService, PageKey, Wrappers10 } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-refer',
  templateUrl: './refer.component.html',
  styleUrls: ['./refer.component.scss']
})
export class ReferComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["refer"]; maxBodyHeight = 0; wrapper: Wrappers10; reasons: KeyValueSet[];
  userId: string = ''; ctryCode: string = ''; interactionType: InteractionType = InteractionType.None;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute, private profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLanguageChanged();
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.configurationManagementService.ensurePageActions(PageKey.Reference);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.profileManagementService.getReference(this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  onLanguageChanged() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.ReferenceReason).subscribe(result => {
      this.reasons = result;
    });
  }

  onAction(index) {
    switch (index) {
      case 1: {
        let content = environment.url.app + this.localService.referencePrefix + this.ctryCode + "-" + this.userId;
        this.localService.copyContent(content);
      } break;
    }
  }
}
